var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackoutDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0923 19.2152L16.8577 17.9806C16.8256 17.987 16.7968 17.9918 16.7711 17.995C16.7455 17.9982 16.7167 17.9999 16.6846 17.9999H3.80772C3.309 17.9999 2.88304 17.8232 2.52984 17.47C2.17663 17.1168 2.00002 16.6909 2.00002 16.1922V3.31525C2.00002 3.2832 2.00163 3.25436 2.00484 3.22873C2.00804 3.20308 2.01605 3.17743 2.02887 3.15178L0.784668 1.8922L1.83849 0.838379L19.1615 18.1614L18.0923 19.2152ZM3.80772 16.4999H15.377L3.49999 4.62291V16.1922C3.49999 16.2819 3.52884 16.3556 3.58654 16.4133C3.64424 16.471 3.71797 16.4999 3.80772 16.4999ZM19 15.1749L17.5 13.6749V5.57681H9.40192L4.82502 0.999904H17.1923C17.691 0.999904 18.1169 1.17651 18.4701 1.52973C18.8234 1.88293 19 2.30889 19 2.80761V15.1749Z",
    fill: "#49A0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackoutDay);
export default __webpack_public_path__ + "static/media/blackout-day.bd9b35d15efa887228be6f1ace578b01.svg";
export { ForwardRef as ReactComponent };